'use es6';

import { useLayoutEffect } from 'react';
import styled from 'styled-components';
import useComponentId from '../hooks/useComponentId';
import { createElement as _createElement } from "react";
const TinyMCEContainer = styled.div.withConfig({
  displayName: "TinymceInline__TinyMCEContainer",
  componentId: "sc-1emrxru-0"
})(({
  $minHeight,
  $maxHeight
}) => {
  const styles = {};
  if ($minHeight) {
    styles['min-height'] = `${$minHeight}px !important`;
  }
  if ($maxHeight) {
    styles['max-height'] = `${$maxHeight}px !important`;
    styles['overflow-y'] = 'auto';
  }
  return styles;
});
const TinymceInline = ({
  className,
  minHeight,
  maxHeight,
  uniqueKey,
  target,
  id,
  content,
  editor,
  initialized,
  config,
  'data-test-id': dataTestId,
  'data-onboarding': dataOnboarding
}) => {
  const inpageWithTarget = target && config.hsInpage;
  const key = useComponentId();

  // The setting of content like this is to avoid dangerously setting markup if inline is running on our domain.
  // inpageWithTarget is a heuristic to know if we should leave the content alone after init
  // This hook is only meant to fire on the change of `initialized` as editor and content props should not be controlled.
  useLayoutEffect(() => {
    if (initialized && !inpageWithTarget) {
      editor.setContent(content);
    }
  }, [initialized, content, editor, inpageWithTarget]);
  if (target) {
    return null;
  }
  const extraProps = config.hsInpage ? {} : {
    translate: 'no'
  };
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _createElement(TinyMCEContainer, Object.assign({}, extraProps, {
      key: uniqueKey || key,
      id: id,
      className: className,
      "data-test-id": dataTestId,
      "data-onboarding": dataOnboarding,
      $minHeight: minHeight,
      $maxHeight: maxHeight
    }))
  );
};
export default TinymceInline;